import { SIZE } from 'baseui/button'
import { useTranslation } from 'react-i18next'
import usePdlSearchV2 from './usePdlSearchV2'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

const PdlSearchButton = ({ hidden = false }) => {
  const { t } = useTranslation()
  const { updatePdlConfigData } = usePdlSearchV2()

  const handleOpenModal = () => {
    updatePdlConfigData({ isOpen: true })
  }

  if (hidden) return null

  return (
    <SDButton
      overrides={{
        BaseButton: {
          style: () => ({
            height: '100%',
            paddingLeft: '.5rem',
            paddingRight: '.5rem',
            letterSpacing: '-0.176px',
          }),
        },
      }}
      size={SIZE.compact}
      id='pdl-search-open-modal'
      onClick={handleOpenModal}
    >
      {t('subscriptionForm:pdl_module.search_text_v2')}
    </SDButton>
  )
}

export default PdlSearchButton
